import React from 'react'
import { EvidencesHome } from '../components/Evidences/EvidencesHome'
import '../css/evidencias.css';

export const EvidencePage = () => {
    return (
        <EvidencesHome />
    )
}
